import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';

import { RankingMethodologySection } from './theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { ThemeExposureTable } from './theme-exposure-table/ThemeExposureTable';
import * as S from './ThemeExposureTab.styles';

export interface ThemeExposureTabProps {
  entity: Entity;
}

export const ThemeExposureTab = ({ entity }: ThemeExposureTabProps) => {
  return (
    <S.Root data-testid="theme-exposure-tab">
      <ErrorBoundaryWrapper
        fallback={
          <>
            <S.StyledErrorMessageWrapper displayIcon />
            <RankingMethodologySection rankingType={'companyToTheme'} />
          </>
        }
      >
        <ThemeExposureTable entity={entity} />
      </ErrorBoundaryWrapper>
    </S.Root>
  );
};
